import { render } from "./ConnectedAgentsTab.vue?vue&type=template&id=3a0af7e6"
import script from "./ConnectedAgentsTab.vue?vue&type=script&lang=js"
export * from "./ConnectedAgentsTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__